import { MOBILE_PRINTER_NUMBER } from '../constants';

export const getMobilePrinterNumber = () => {
  try {
    return localStorage.getItem(MOBILE_PRINTER_NUMBER) || '';
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error getting mobile printer number from storage:', error);
    return '';
  }
};

export const isMobilePrinterConnected = () => {
  return !!getMobilePrinterNumber();
};

export const removeMobilePrinterFromStorage = () => {
  try {
    localStorage.removeItem(MOBILE_PRINTER_NUMBER);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error removing mobile printer number from storage:', error);
  }
};

export const saveMobilePrinterToStorage = (printerNumber: string) => {
  try {
    localStorage.setItem(MOBILE_PRINTER_NUMBER, printerNumber);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error saving mobile printer number to storage:', error);
  }
};
